  <div class="modal-header">
    <h4 class="modal-title pull-left">
      {{ 'projectExportEshopWatchlist.title' | translate }}
    </h4>
  </div>

<div class="modal-body pt-0">
  <div class="modal-body-inner" *ngIf="(existingWatchLists$ | async) as existingWatchLists">
    <div class="flex-grow-1 align-items-stretch">

      <div id="watchlist-name-description" class="pb-3">
        {{ 'projectExportEshopWatchlist.watchlist_name' | translate }}
      </div>

      <table class="table table-hover table-striped table-overflow-hidden fixed-layout" data-testid="existing-watchlists" aria-describedby="watchlist-name-description">
        <tbody>
          <tr *ngFor="let watchListName of existingWatchLists"
              (click)="selectExisting(watchListName)"
              [class.active]="watchlistNameFormControl.value == watchListName"
              class="c-pointer"
          >
            <td>{{watchListName}}</td>
          </tr>
        </tbody>
      </table>

      <form *ngIf="existingWatchLists.length < 10" [formGroup]="watchlistDataForm" class="mt-3" (submit)="export()">
        <div class="py-1 row">
          <label class="col-md-4 col-form-label">{{ 'projectExportEshopWatchlist.watchlist_name.label' | translate }} </label>
          <div class="col-md-6">
            <input
              type="text"
              id="watchlist-name"
              name="watchlist-name"
              class="form-control"
              [placeholder]="('projectExportEshopWatchlist.watchlist_name.placeholder' | translate) + ' ' + projectName"
              [class.is-invalid]="watchlistNameFormControl?.dirty && watchlistNameFormControl?.invalid"
              formControlName="watchlistNameFormControl"
              data-testid="new-watchlist-input"/>
            <div class="invalid-feedback">{{ 'global.label.legend_required_field' | translate }}</div>
          </div>
        </div>
      </form>

      <p *ngIf="existingWatchLists.length >= 10">
        {{ 'projectExportEshopWatchlist.watchlist_limit_reached' | translate }}
      </p>

    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">
    {{ 'global.label.cancel' | translate }}
  </button>
  <button class="btn btn-primary btn-forward" data-testid="export-watchlist-submit" [disabled]="watchlistNameFormControl?.invalid" appActionLogId="eshop_watchlist.exported" (click)="export()">
    {{ 'global.label.continue' | translate }}
  </button>
</div>
